import React, { Component } from 'react';
import reduxForm from 'redux-form/lib/reduxForm';
import { injectStripe } from 'react-stripe-elements';
import PaymentForm from './PaymentForm';
import validate from './validate';
import { CREDIT_CARD_FORM_NAME } from './constants';

// note - injectStripe component must be a child of a component using <Elements />
export default injectStripe(
  reduxForm({
    form: CREDIT_CARD_FORM_NAME,
    validate,
  })(PaymentForm)
);
